import { HOTEL } from "@/data/site";
import { BookDirect } from "@/components/CTAButtons";
import { trackCta } from "@/lib/analytics";
import { motion, AnimatePresence } from "framer-motion";
import { useState, useEffect } from "react";
import { Phone } from "lucide-react";

export const StickyBook = () => {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 600);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <>
      <AnimatePresence>
        {show && (
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 30 }}
            className="fixed bottom-8 right-8 z-[100] hidden md:block"
          >
            <BookDirect label="Book Direct · Best Rate" testid="sticky-book-desktop" className="px-7 py-4 text-base shadow-xl" />
          </motion.div>
        )}
      </AnimatePresence>

      {/* Mobile bottom bar */}
      <div className="fixed inset-x-0 bottom-0 z-[100] grid grid-cols-2 border-t-2 border-charcoal bg-paper md:hidden">
        <a
          href={`tel:${HOTEL.phone}`}
          data-testid="sticky-call-mobile"
          onClick={() => trackCta("call")}
          className="flex items-center justify-center gap-2 py-4 font-heading font-black uppercase text-charcoal"
        >
          <Phone className="h-4 w-4" /> Call
        </a>
        <a
          href={HOTEL.bookUrl}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="sticky-book-mobile"
          onClick={() => trackCta("book")}
          className="flex items-center justify-center bg-brand-yellow py-4 font-heading font-black uppercase text-black"
        >
          Book Direct
        </a>
      </div>
    </>
  );
};
